<template>
    <v-panel v-model="popStatus" title="选择图片" :mask-closable="false" :width="851" @close="handlerCancel">
        <div class="img-picker-pop-body">
            <div class="img-pick-upload">
                <div>
                    <v-select placeholder="请选择" v-model="groupId" :options="optionsSelect" max-height="264" @change="handleGroupChange"></v-select>
                </div>
                <div>
                    <a href="/mp/imgMaterial">上传图片</a>
                    <!-- <v-uploader url="/mp/imgTmp/create?type=upload" name="sample" form-key="lbf-file-upload"
                        :data="uploadData" :size-limit="uploadData.file_size_limit" :type-limit="uploadData.file_types"
                        :show-list="false" :show-progress="false" @start="onStart" @error="onError"
                        @complete="onComplete">
                        <v-button icon="basic_upload2_line" remote :loading="uploading"
                            :disabled="uploading">上传</v-button>
                    </v-uploader>
                    <span class="upload-tips">文件小于2M，格式：bmp, jpeg, jpg, gif, png</span> -->

                </div>
            </div>
            <Empty v-if="!totalPage" />
            <div class="img-picker-container">
                <ImgPicker :list="list" :selected="selected" @handlerSelected="handlerSelected" />
            </div>
            <ReplyLoading v-if="loading" />
            <ReplyPagination v-show="totalPage" :total="totalPage" :text="paginationExtraText" :count="count" @change="onPageChange" />
            <div v-show="!totalPage" style="position: absolute; left: 0; right: 0; bottom: 0; height: 62px; background-color: #edeff2;"></div>
        </div>

        <div class="img-picker-operator">
            <v-button :disabled="!selected.id" style="margin-right: 15px;" size="large" kind="primary"
                @click="handlerOk">确定</v-button>
            <v-button size="large" @click="handlerCancel">取消</v-button>
        </div>
    </v-panel>
</template>

<script>
import axios from 'axios';
import Cookie from '@/utils/cookie';
import ImgPicker from './img-picker';
import getImgSize from './utils/getImgSize';
import ReplyPagination from './components/reply-pagination';
import ReplyLoading from './components/reply-loading';
import Empty from '@/components/empty';

const imgListUrl = '/mp/rest/imgMaterial';
const groupList = '/mp/materialGroup/list?index=1&count=100&groupType=image'

export default {
    name: 'PopImgPicker',
    components: {
        ImgPicker,
        ReplyPagination,
        ReplyLoading,
        Empty
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        picker: {
            type: Object,
            default: () => ({}),
        }
    },
    data() {
        return {
            popStatus: false,
            list: [],
            loading: false,
            uploading: false,
            selected: this.picker,
            currentPage: 1,
            totalPage: 0,
            uploadData: {
                file_size_limit: '2MB',
                file_types: '*.bmp;*.png;*.jpg;*.jpeg;*.gif;*.webp',
                _bqq_csrf: Cookie.get('_bqq_csrf') || null
            },
            count: 50, // 每页展示个数 分页器只支持 10 30 50
            optionsSelect: [],
            groupId: -1,
        };
    },
    computed: {
        paginationExtraText() {
            return `共 ${this.totalPage} 张图片`;
        }
    },
    watch: {
        show(newValue) {
            if (newValue && !this.list.length) {
                this.fetchList(this.currentPage);
            }
            this.popStatus = newValue;
        },
        currentPage(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.fetchList(newValue);
            }
        },
        picker(newValue) {
            this.selected = newValue;
        }
    },
    mounted() {
        this.featchGroupList();
    },
    methods: {
        handlerSelected(item) {
            this.selected = item.id === this.selected.id ? {} : item;
        },

        onStart() {
            this.uploading = true;
        },
        onComplete() {
            this.uploading = false;
            this.currentPage = 1;
            this.fetchList(this.currentPage);
        },
        onError(err) {
            const { type } = (err && err.origin) || {};
            let errMsg = '';
            switch (type) {
                case 'TYPE':
                    errMsg = '图片格式不支持';
                    break;
                case 'SIZE':
                    errMsg = '文件超过了2M';
                    break;
                default:
                    errMsg = '上传出错';
                    break;
            }
            this.$message.error(errMsg);
        },
        onPageChange(page) {
            this.currentPage = page;
        },
        fetchList(page) {
            this.loading = true;
            this.list = [];
            axios({
                method: 'get',
                url: imgListUrl,
                params: {
                    index: page,
                    count: this.count,
                    groupId: this.groupId,
                }
            }).then(res => {
                const { records } = res;
                records.forEach(item => {
                    item.showUrl = item.showUrl && item.showUrl.replace(/\/0$/, '/360');
                });

                Promise.all(
                    records.map(
                        item =>
                            new Promise(resolve =>
                                getImgSize(item.showUrl).then(ret => resolve(Object.assign(item, ret)))
                            )
                    )
                )
                    .then(data => {
                        this.list = data;
                        this.totalPage = res.total;
                    })
                    .catch(() => { })
                    .then(() => {
                        this.loading = false;
                    });
            });
        },
        featchGroupList() {
            axios({
                method: 'get',
                url: groupList
            }).then(res => {
                if (res.code === 0) {
                    this.optionsSelect = res.data.map(item => ({
                        value: item.id,
                        text: item.name
                    }));
                }
            })
        },
        handlerOk() {
            this.$emit('handler-ok', this.selected);
        },
        handlerCancel() {
            // 取消时，使用传入的props恢复selected
            this.selected = this.picker;
            this.$emit('handler-cancel');
        },
        handleGroupChange(id) {
            this.currentPage = 1;
            this.groupId = id;
            this.fetchList(this.currentPage);
        }
    }
};
</script>

<style>
.clearfix::after {
    content: '';
    display: block;
    clear: both;
    height: 0;
}

.img-pick-upload {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 24px;
    padding-left: 16px;
    text-align: left;
    background-color: #edeff2;
}

.img-pick-upload .v-uploader__tip {
    display: none;
}

.img-picker-operator {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 0 25px 25px;
    text-align: center;
}

.img-picker-pop-body {
    position: absolute;
    top: 52px;
    bottom: 90px;
    right: 0;
    left: 0;
}

.img-picker-pop-body .v-pagination {
    padding: 0;
}

.upload-tips {
    display: inline-block;
    margin-left: 10px;
    color: #a8abb3;
    vertical-align: middle;
}

.img-picker-container {
    position: absolute;
    top: 50px;
    bottom: 60px;
    right: 0;
    left: 0;
    overflow: auto;
    padding-left: 15px;
    background-color: #edeff2;
    border: none;
}
</style>

<style lang="less" scoped>
/deep/.v-panel__header {
    text-align: left;
    padding-left: 24px;
}

/deep/.v-uploader {
    margin-top: 0 !important;
}

/deep/ .v-select {
    margin-top: 0 !important;
}
</style>
